"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientTransport = void 0;
const runtime_rpc_1 = require("@protobuf-ts/runtime-rpc");
const uuid_1 = require("uuid");
const eventemitter3_1 = __importDefault(require("eventemitter3"));
const utils_1 = require("@streamr/utils");
const any_1 = require("../generated/google/protobuf/any");
const logger = new utils_1.Logger(module);
class ClientTransport extends eventemitter3_1.default {
    static objectCount = 0;
    objectId;
    defaultOptions;
    constructor(defaultTimeout = 5000) {
        super();
        this.objectId = ClientTransport.objectCount++;
        this.defaultOptions = {
            timeout: defaultTimeout,
            clientId: this.objectId
        };
    }
    mergeOptions(options) {
        return (0, runtime_rpc_1.mergeRpcOptions)(this.defaultOptions, options);
    }
    static createRequestHeaders(method, notification) {
        return {
            method: method.localName,
            request: 'request',
            notification: notification ? 'notification' : undefined
        };
    }
    unary(method, input, options) {
        if (!options?.isProtoRpc) {
            // eslint-disable-next-line max-len
            throw new Error('ProtoRpc ClientTransport can only be used with ProtoRpcClients. Please convert your protobuf-ts generated client to a ProtoRpcClient by calling toProtoRpcclient(yourClient).');
        }
        const requestBody = any_1.Any.pack(input, method.I);
        const request = {
            header: ClientTransport.createRequestHeaders(method, options.notification),
            body: requestBody,
            requestId: (0, uuid_1.v4)()
        };
        const defHeader = new runtime_rpc_1.Deferred();
        const defMessage = new runtime_rpc_1.Deferred();
        const defStatus = new runtime_rpc_1.Deferred();
        const defTrailer = new runtime_rpc_1.Deferred();
        const unary = new runtime_rpc_1.UnaryCall(method, {}, input, defHeader.promise, defMessage.promise, defStatus.promise, defTrailer.promise);
        const deferredParser = (bytes) => method.O.fromBinary(bytes);
        const deferred = {
            message: defMessage,
            header: defHeader,
            trailer: defTrailer,
            status: defStatus,
            messageParser: deferredParser
        };
        logger.trace(`New rpc ${options.notification ? 'notification' : 'request'}, ${request.requestId}`);
        this.emit('rpcRequest', request, options, deferred);
        return unary;
    }
    // eslint-disable-next-line class-methods-use-this
    clientStreaming(method) {
        const e = new runtime_rpc_1.RpcError('Client streaming is not supported by DhtTransport');
        e.methodName = method.name;
        e.serviceName = method.service.typeName;
        throw e;
    }
    // eslint-disable-next-line class-methods-use-this
    duplex(method) {
        const e = new runtime_rpc_1.RpcError('Duplex streaming is not supported by DhtTransport');
        e.methodName = method.name;
        e.serviceName = method.service.typeName;
        throw e;
    }
    // eslint-disable-next-line class-methods-use-this
    serverStreaming(method) {
        const e = new runtime_rpc_1.RpcError('Server streaming is not supported by DhtTransport');
        e.methodName = method.name;
        e.serviceName = method.service.typeName;
        throw e;
    }
    stop() {
        this.removeAllListeners();
    }
}
exports.ClientTransport = ClientTransport;
//# sourceMappingURL=ClientTransport.js.map